import DropDown from "./components/dropDown.js";

window.addEventListener("DOMContentLoaded", () => {
  const dropDown = new DropDown();
});
